var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"g-my-module-style-box"},[_c('ul',{staticClass:"u-list"},_vm._l((_vm.options),function(item,i){return _c('li',{key:i,staticClass:"u-li",attrs:{"data-active":item.value === _vm.value},on:{"click":function($event){return _vm.selectStyle(item.value)}}},[_c('div',{staticClass:"u-img",style:(_vm.style(item))})])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b1dfd42","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/my_module_style/index.vue
// module id = null
// module chunks = 